(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var cartItems = document.querySelectorAll('.cart-item');
    
    cartItems.forEach(function(item) {
      var decreaseBtn = item.querySelector('[data-action="decrease"]');
      var increaseBtn = item.querySelector('[data-action="increase"]');
      var input = item.querySelector('.cart-item__quantity-input');
      
      if (decreaseBtn && input) {
        decreaseBtn.addEventListener('click', function() {
          var currentValue = parseInt(input.value, 10);
          if (currentValue > 0) {
            input.value = currentValue - 1;
          }
        });
      }
      
      if (increaseBtn && input) {
        increaseBtn.addEventListener('click', function() {
          var currentValue = parseInt(input.value, 10);
          input.value = currentValue + 1;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var dropdowns = document.querySelectorAll('.collection-page__dropdown');

    dropdowns.forEach(function(dropdown) {
      var btn = dropdown.querySelector('.collection-page__dropdown-btn');
      var menu = dropdown.querySelector('.collection-page__dropdown-menu');
      var type = dropdown.dataset.dropdown;

      // Toggle dropdown on button click
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = dropdown.dataset.open === 'true';
        
        // Close all other dropdowns
        dropdowns.forEach(function(d) {
          d.dataset.open = 'false';
          d.querySelector('.collection-page__dropdown-btn').setAttribute('aria-expanded', 'false');
        });

        // Toggle current dropdown
        if (!isOpen) {
          dropdown.dataset.open = 'true';
          btn.setAttribute('aria-expanded', 'true');
        }
      });

      // Handle option selection
      menu.addEventListener('click', function(e) {
        var option = e.target.closest('li[role="option"]');
        if (!option) return;

        var value = option.dataset.value;
        var url = new URL(window.location.href);

        if (type === 'sort') {
          if (value && value !== 'manual') {
            url.searchParams.set('sort_by', value);
          } else {
            url.searchParams.delete('sort_by');
          }
          window.location.href = url.toString();
        } else if (type === 'filter') {
          var pathname = url.pathname;
          
          if (value) {
            // Remove existing tag from pathname if present
            var pathParts = pathname.split('/');
            var collectionIndex = pathParts.indexOf('collections');
            if (collectionIndex !== -1 && pathParts.length > collectionIndex + 2) {
              pathParts.splice(collectionIndex + 2, 1);
            }
            pathname = pathParts.join('/') + '/' + value;
          } else {
            // Remove tag from pathname
            var pathParts = pathname.split('/');
            var collectionIndex = pathParts.indexOf('collections');
            if (collectionIndex !== -1 && pathParts.length > collectionIndex + 2) {
              pathParts.splice(collectionIndex + 2, 1);
            }
            pathname = pathParts.join('/');
          }
          
          url.pathname = pathname;
          window.location.href = url.toString();
        }
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function() {
      dropdowns.forEach(function(dropdown) {
        dropdown.dataset.open = 'false';
        dropdown.querySelector('.collection-page__dropdown-btn').setAttribute('aria-expanded', 'false');
      });
    });

    // Close dropdowns on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        dropdowns.forEach(function(dropdown) {
          dropdown.dataset.open = 'false';
          dropdown.querySelector('.collection-page__dropdown-btn').setAttribute('aria-expanded', 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var carousel = document.querySelector('.featured-collections__carousel');
    if (!carousel) return;

    var track = carousel.querySelector('.featured-collections__track');
    var dotsContainer = document.querySelector('.featured-collections__dots');
    var items = track.querySelectorAll('.featured-collections__item');

    if (items.length > 0) {
      // Mouse drag functionality (for desktop testing mobile view)
      var isDragging = false;
      var startX;
      var scrollLeft;

      track.addEventListener('mousedown', function(e) {
        isDragging = true;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        track.style.cursor = 'grabbing';
      });

      track.addEventListener('mouseleave', function() {
        if (!isDragging) return;
        isDragging = false;
        track.style.scrollSnapType = '';
        track.style.scrollBehavior = 'smooth';
        track.style.cursor = '';
      });

      track.addEventListener('mouseup', function() {
        if (!isDragging) return;
        isDragging = false;
        track.style.scrollSnapType = '';
        track.style.scrollBehavior = 'smooth';
        track.style.cursor = '';
      });

      track.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        e.preventDefault();
        var x = e.pageX - track.offsetLeft;
        var walk = (x - startX) * 1.5;
        track.scrollLeft = scrollLeft - walk;
      });

      // Prevent native image dragging
      track.addEventListener('dragstart', function(e) {
        e.preventDefault();
      });

      // Create dots
      items.forEach(function(item, index) {
        var dot = document.createElement('button');
        dot.className = 'featured-collections__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        if (index === 0) dot.classList.add('is-active');
        
        dot.addEventListener('click', function() {
          var itemWidth = items[0].offsetWidth;
          var gap = parseFloat(getComputedStyle(track).gap) || 0;
          
          track.scrollTo({
            left: (itemWidth + gap) * index,
            behavior: 'smooth'
          });
        });
        
        dotsContainer.appendChild(dot);
      });

      // Update active dot on scroll
      track.addEventListener('scroll', function() {
        var scrollLeft = track.scrollLeft;
        var itemWidth = items[0].offsetWidth;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        var currentIndex = Math.round(scrollLeft / (itemWidth + gap));
        
        var dots = dotsContainer.querySelectorAll('.featured-collections__dot');
        dots.forEach(function(dot, index) {
          if (index === currentIndex) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.header');
    if (!header) return;

    var hamburger = header.querySelector('.header__hamburger');
    var sidebar = header.querySelector('.header__sidebar');
    var overlay = header.querySelector('.header__overlay');
    var sidebarClose = header.querySelector('.header__sidebar-close');

    // Drawers
    var drawers = document.querySelectorAll('.drawer');
    var drawerOpenBtns = document.querySelectorAll('[data-drawer-open]');
    var drawerCloseBtns = document.querySelectorAll('[data-drawer-close]');

    // Search Drawer
    var searchInput = header.querySelector('[data-search-input]');
    var searchResults = header.querySelector('[data-search-results]');
    var searchGrid = header.querySelector('[data-search-grid]');
    var searchEmpty = header.querySelector('[data-search-empty]');
    var searchSuggestions = header.querySelector('[data-search-suggestions]');
    var searchTimeout = null;
    var newPriceLabel = header.getAttribute('data-new-price-label') || 'New price';

    // Cart Drawer
    var cartDrawer = header.querySelector('[data-cart-drawer]');
    var cartItemsContainer = header.querySelector('[data-cart-items]');
    var cartFooter = header.querySelector('[data-cart-footer]');
    var cartCount = header.querySelector('[data-cart-count]');

    // Drawer Logic
    function openDrawer(id) {
      if (sidebar.classList.contains('is-open')) {
        closeSidebar();
      }
      drawers.forEach(function (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      });
      var target = document.getElementById(id);
      if (target) {
        target.classList.add('is-open');
        target.setAttribute('aria-hidden', 'false');
        overlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';

        if (id === 'drawer-search') {
          setTimeout(function () {
            searchInput.focus();
          }, 300);
        }
      }
    }

    // Listen for custom cart:updated event to open cart drawer
    window.addEventListener('cart:updated', function() {
      fetchCart().then(function() {
        openDrawer('drawer-cart');
      });
    });

    function closeAllDrawers() {
      drawers.forEach(function (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      });
      overlay.classList.remove('is-visible');
      document.body.style.overflow = '';

      // reset search
      if (searchInput) {
        searchInput.value = '';
        searchResults.style.display = 'none';
        searchSuggestions.style.display = 'flex';
      }
    }

    drawerOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-drawer-open');
        if (id === 'drawer-cart') {
          fetchCart().then(function() {
            openDrawer(id);
          });
        } else {
          openDrawer(id);
        }
      });
    });

    drawerCloseBtns.forEach(function (btn) {
      btn.addEventListener('click', closeAllDrawers);
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeSidebar();
        closeAllDrawers();
      });
    }

    // Sidebar Menu functions
    function openSidebar() {
      closeAllDrawers();
      sidebar.classList.add('is-open');
      overlay.classList.add('is-visible');
      hamburger.classList.add('is-active');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      sidebar.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      hamburger.classList.remove('is-active');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (hamburger) {
      hamburger.addEventListener('click', function () {
        if (sidebar.classList.contains('is-open')) {
          closeSidebar();
        } else {
          openSidebar();
        }
      });
    }

    if (sidebarClose) {
      sidebarClose.addEventListener('click', closeSidebar);
    }

    // Utilities
    function isMobile() {
      return window.innerWidth <= 768;
    }

    function formatMoney(cents) {
      var moneyFormat = header.getAttribute('data-money-format') || '$\u007B\u007Bamount\u007D\u007D';
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.floor(cents / 100).toString();
      var amountWithComma = amount.replace('.', ',');
      var amountNoDecimalsWithComma = amountNoDecimals;

      function addThousandsSep(numStr, sep) {
        return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      }

      var amountWithThousands = addThousandsSep(amount.split('.')[0], ',') + '.' + amount.split('.')[1];
      var amountNoDecimalsWithThousands = addThousandsSep(amountNoDecimals, ',');
      var amountWithCommaAndPeriodThousands = addThousandsSep(amount.split('.')[0], '.') + ',' + amount.split('.')[1];
      var amountNoDecimalsWithPeriodThousands = addThousandsSep(amountNoDecimals, '.');

      var formatted = moneyFormat;

      if (formatted.indexOf('\u007B\u007Bamount_with_comma_separator\u007D\u007D') !== -1) {
        formatted = formatted.replace('\u007B\u007Bamount_with_comma_separator\u007D\u007D', amountWithCommaAndPeriodThousands);
      } else if (formatted.indexOf('\u007B\u007Bamount_no_decimals_with_comma_separator\u007D\u007D') !== -1) {
        formatted = formatted.replace(
          '\u007B\u007Bamount_no_decimals_with_comma_separator\u007D\u007D',
          amountNoDecimalsWithPeriodThousands
        );
      } else if (formatted.indexOf('\u007B\u007Bamount_no_decimals\u007D\u007D') !== -1) {
        formatted = formatted.replace('\u007B\u007Bamount_no_decimals\u007D\u007D', amountNoDecimalsWithThousands);
      } else if (formatted.indexOf('\u007B\u007Bamount\u007D\u007D') !== -1) {
        formatted = formatted.replace('\u007B\u007Bamount\u007D\u007D', amountWithThousands);
      }
      return formatted;
    }

    function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    // Search Logic
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimeout);
        var query = this.value.trim();
        searchTimeout = setTimeout(function () {
          performSearch(query, searchResults, searchGrid, searchEmpty);
        }, 300);
      });
    }

    function performSearch(query, resultsEl, gridEl, emptyEl) {
      if (!query || query.length < 2) {
        resultsEl.style.display = 'none';
        searchSuggestions.style.display = 'flex';
        gridEl.innerHTML = '';
        emptyEl.style.display = 'none';
        return;
      }

      searchSuggestions.style.display = 'none';
      resultsEl.style.display = 'block';

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4')
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var products = data.resources.results.products || [];

          if (products.length === 0) {
            emptyEl.style.display = 'block';
            gridEl.innerHTML = '';
          } else {
            emptyEl.style.display = 'none';
            renderProducts(products, gridEl);
          }
        })
        .catch(function (error) {
          console.error('Search error:', error);
        });
    }

    function renderProducts(products, gridEl) {
      var html = '';
      products.forEach(function (product) {
        var imageUrl = product.featured_image ? product.featured_image.url + '&width=300&height=400&crop=center' : '';
        
        var priceVal = parseFloat(product.price);
        var compareAtPriceVal = parseFloat(product.compare_at_price_min || product.compare_at_price || 0);
        var onSale = compareAtPriceVal > priceVal;
        
        var priceFormatted = formatMoney(priceVal * 100);
        var compareAtPriceFormatted = onSale ? formatMoney(compareAtPriceVal * 100) : '';
        
        var discountPercentage = 0;
        if (onSale) {
          discountPercentage = Math.round(((compareAtPriceVal - priceVal) * 100) / compareAtPriceVal);
        }

        html += '<div class="product-card">';
        html += '<a href="' + product.url + '" class="product-card__link">';
        html += '<div class="product-card__image-wrapper">';
        if (imageUrl) {
          html +=
            '<img src="' +
            imageUrl +
            '" alt="' +
            escapeHtml(product.title) +
            '" class="product-card__image" loading="lazy">';
        }
        html += '</div>';
        
        html += '<div class="product-card__content">';
        html += '<div class="product-label" style="display:none;"></div>';
        html += '<h3 class="product-card__title">' + escapeHtml(product.title) + '</h3>';
        
        // Variant name
        var firstVariantTitle = '';
        if (product.variants && product.variants.length > 0) {
          firstVariantTitle = product.variants[0].title;
        }
        if (firstVariantTitle && firstVariantTitle !== 'Default Title') {
          html += '<p class="product-card__variant">' + escapeHtml(firstVariantTitle) + '</p>';
        }
        
        // Pricing
        html += '<div class="product-card__price">';
        if (onSale) {
          html += '<div class="product-card__price-wrapper">';
          html += '  <span class="product-card__price-old">' + compareAtPriceFormatted + '</span>';
          html += '  <div class="product-card__price-sale">';
          html += '    <span class="product-card__price-label">' + escapeHtml(newPriceLabel) + '</span>';
          html += '    <span class="product-card__price-current">' + priceFormatted + '</span>';
          html += '    <span class="product-card__price-discount">-' + discountPercentage + '%</span>';
          html += '  </div>';
          html += '</div>';
        } else {
          html += '<span class="product-card__price-current">' + priceFormatted + '</span>';
        }
        html += '</div>'; // close product-card__price
        
        html += '</div>'; // close product-card__content
        html += '</a></div>';
      });
      gridEl.innerHTML = html;
    }

    // Cart Logic
    function fetchCart() {
      return fetch('/cart.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          renderCartDrawer(cart);
          updateCartIconCount(cart.item_count);
        })
        .catch(function (err) {
          console.error('Cart fetch err', err);
        });
    }

    function updateCart(line, quantity) {
      var formData = {
        line: line,
        quantity: parseInt(quantity),
      };

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          renderCartDrawer(cart);
          updateCartIconCount(cart.item_count);
        });
    }

    function updateCartIconCount(count) {
      if (cartCount) {
        if (count > 0) {
          cartCount.textContent = count;
          cartCount.style.display = 'flex';
        } else {
          cartCount.style.display = 'none';
        }
      }
    }

    function renderCartDrawer(cart) {
      if (cart.item_count === 0) {
        cartItemsContainer.innerHTML =
          '<p class="header__cart-empty">' +
          escapeHtml(header.getAttribute('data-empty-text') || 'Your cart is empty') +
          '</p>';
        cartFooter.style.display = 'none';
        return;
      }

      var html = '';
      cart.items.forEach(function (item, index) {
        var lineIndex = index + 1; // Shopify uses 1-based index for line items
        var imageUrl = item.featured_image ? item.featured_image.url + '&width=120&height=160&crop=center' : '';
        var variantTitle = item.variant_title || '';

        html += '<div class="drawer__cart-item">';
        html += '<a href="' + item.url + '" class="drawer__cart-item-image">';
        if (imageUrl) {
          html += '<img src="' + imageUrl + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">';
        }
        html += '</a>';

        html += '<div class="drawer__cart-item-details">';
        html += '  <div class="drawer__cart-item-header">';
        html += '    <div class="drawer__cart-item-title-col">';
        html +=
          '      <a href="' + item.url + '" class="drawer__cart-item-title">' + escapeHtml(item.product_title) + '</a>';
        if (variantTitle && variantTitle !== 'Default Title') {
          html += '      <p class="drawer__cart-item-variant">' + escapeHtml(variantTitle) + '</p>';
        }
        html += '    </div>';
        html += '    <button type="button" class="drawer__cart-item-remove" data-line="' + lineIndex + '">';
        html +=
          '      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        html += '    </button>';
        html += '  </div>';

        html += '  <div class="drawer__cart-item-footer">';
        html += '    <div class="drawer__cart-qty">';
        html +=
          '      <button type="button" class="drawer__cart-qty-btn" data-action="minus" data-line="' +
          lineIndex +
          '" data-qty="' +
          item.quantity +
          '">-</button>';
        html += '      <input type="number" class="drawer__cart-qty-input" value="' + item.quantity + '" readonly>';
        html +=
          '      <button type="button" class="drawer__cart-qty-btn" data-action="plus" data-line="' +
          lineIndex +
          '" data-qty="' +
          item.quantity +
          '">+</button>';
        html += '    </div>';
        html += '    <p class="drawer__cart-item-price">' + formatMoney(item.original_line_price) + '</p>';
        html += '  </div>';
        html += '</div>';
        html += '</div>';
      });

      cartItemsContainer.innerHTML = html;
      cartFooter.style.display = 'block';

      // Attach events to cart items
      var removeBtns = cartItemsContainer.querySelectorAll('.drawer__cart-item-remove');
      removeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          updateCart(btn.getAttribute('data-line'), 0);
        });
      });

      var qtyBtns = cartItemsContainer.querySelectorAll('.drawer__cart-qty-btn');
      qtyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var action = btn.getAttribute('data-action');
          var currentQty = parseInt(btn.getAttribute('data-qty'), 10);
          var line = btn.getAttribute('data-line');
          var newQty = action === 'plus' ? currentQty + 1 : currentQty - 1;
          if (newQty > 0) {
            updateCart(line, newQty);
          } else if (newQty === 0) {
            updateCart(line, 0); // Remove
          }
        });
      });
    }

    // Global Keydown
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeSidebar();
        closeAllDrawers();
      }
    });

    // Desktop dropdowns (from older code)
    function initDesktopDropdowns() {
      var menuItems = header.querySelectorAll('.header__menu-item--has-dropdown');
      menuItems.forEach(function (item) {
        var link = item.querySelector('.header__menu-link');
        var dropdown = item.querySelector('.header__dropdown');
        var closeTimeout = null;

        function openDropdown() {
          clearTimeout(closeTimeout);
          menuItems.forEach(function (otherItem) {
            if (otherItem !== item) {
              var otherLink = otherItem.querySelector('.header__menu-link');
              var otherDropdown = otherItem.querySelector('.header__dropdown');
              otherLink.setAttribute('aria-expanded', 'false');
              otherDropdown.classList.remove('is-visible');
            }
          });
          var itemRect = item.getBoundingClientRect();
          dropdown.style.left = -itemRect.left + 'px';
          link.setAttribute('aria-expanded', 'true');
          dropdown.classList.add('is-visible');
        }

        function scheduleClose() {
          closeTimeout = setTimeout(function () {
            link.setAttribute('aria-expanded', 'false');
            dropdown.classList.remove('is-visible');
          }, 80);
        }

        item.addEventListener('mouseenter', openDropdown);
        item.addEventListener('mouseleave', scheduleClose);

        dropdown.addEventListener('mouseenter', function () {
          clearTimeout(closeTimeout);
        });
        dropdown.addEventListener('mouseleave', scheduleClose);
      });
    }

    // Account switcher
    function initAccountSwitcher() {
      var accountSwitcher = header.querySelector('[data-account-switcher]');
      if (!accountSwitcher) return;
      var accountToggle = accountSwitcher.querySelector('[data-account-toggle]');
      var accountDropdown = accountSwitcher.querySelector('[data-account-dropdown]');

      accountToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = accountDropdown.classList.contains('is-visible');
        if (isOpen) {
          accountDropdown.classList.remove('is-visible');
          accountToggle.setAttribute('aria-expanded', 'false');
        } else {
          accountDropdown.classList.add('is-visible');
          accountToggle.setAttribute('aria-expanded', 'true');
        }
      });

      accountDropdown.addEventListener('click', function (e) {
        e.stopPropagation();
      });

      document.addEventListener('click', function () {
        accountDropdown.classList.remove('is-visible');
        accountToggle.setAttribute('aria-expanded', 'false');
      });
    }

    // Language switcher
    function initLangSwitcher() {
      var langSwitcher = header.querySelector('[data-lang-switcher]');
      if (!langSwitcher) return;
      var langToggle = langSwitcher.querySelector('[data-lang-toggle]');
      var langDropdown = langSwitcher.querySelector('[data-lang-dropdown]');

      langToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = langDropdown.classList.contains('is-visible');
        if (isOpen) {
          langDropdown.classList.remove('is-visible');
          langToggle.setAttribute('aria-expanded', 'false');
        } else {
          langDropdown.classList.add('is-visible');
          langToggle.setAttribute('aria-expanded', 'true');
        }
      });
      document.addEventListener('click', function () {
        langDropdown.classList.remove('is-visible');
        langToggle.setAttribute('aria-expanded', 'false');
      });
    }

    // Sidebar toggles (mobile accordion menu)
    function initSidebarToggles() {
      var toggleButtons = sidebar.querySelectorAll('.header__sidebar-toggle');
      toggleButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          var isExpanded = button.getAttribute('aria-expanded') === 'true';
          var parentItem = button.parentElement;
          var sublist = parentItem.querySelector('.header__sidebar-sublist');

          toggleButtons.forEach(function (otherButton) {
            if (otherButton !== button) {
              var otherParent = otherButton.parentElement;
              var otherSublist = otherParent.querySelector('.header__sidebar-sublist');
              if (otherButton.getAttribute('aria-expanded') === 'true') {
                otherButton.setAttribute('aria-expanded', 'false');
                if (otherSublist) otherSublist.style.maxHeight = '0';
                otherParent.classList.remove('is-expanded');
              }
            }
          });

          if (sublist) {
            if (isExpanded) {
              button.setAttribute('aria-expanded', 'false');
              sublist.style.maxHeight = '0';
              parentItem.classList.remove('is-expanded');
            } else {
              button.setAttribute('aria-expanded', 'true');
              var nestedSublists = sublist.querySelectorAll('.header__sidebar-sublist--nested');
              nestedSublists.forEach(function (nested) {
                nested.style.maxHeight = 'none';
              });
              sublist.style.maxHeight = sublist.scrollHeight + 'px';
              parentItem.classList.add('is-expanded');
            }
          }
        });
      });
    }

    initSidebarToggles();
    initLangSwitcher();
    initAccountSwitcher();
    if (window.innerWidth > 768) {
      initDesktopDropdowns();
    }

    window.addEventListener('resize', function () {
      if (window.innerWidth > 768) {
        closeSidebar();
      }
    });

    // shop-login-button signals completion via postMessage from the same origin,
    // with data: { type: 'completed', shopSignIn: true }.
    if (header.querySelector('[data-account-login]')) {
      function onShopLoginMessage(event) {
        var d = event.data;
        if (d && d.type === 'completed' && d.shopSignIn === true) {
          window.removeEventListener('message', onShopLoginMessage);
          window.location.reload();
        }
      }
      window.addEventListener('message', onShopLoginMessage);
    }

    // Fallback: bfcache restore after a redirect-based login flow — force a fresh load.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.querySelector('.newsletter__form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      var input = form.querySelector('.newsletter__input');
      var email = input.value;

      if (!email) return;

      // Submit the form
      var formData = new FormData(form);
      
      fetch('/contact#newsletter-form', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/javascript'
        }
      })
      .then(function(response) {
        if (response.ok) {
          input.value = '';
          input.placeholder = 'GRACIAS POR SUSCRIBIRTE';
          setTimeout(function() {
            input.placeholder = form.querySelector('.newsletter__input').getAttribute('placeholder') || 'DIRECCIÓN DE CORREO ELECTRÓNICO';
          }, 3000);
        }
      })
      .catch(function(error) {
        console.error('Newsletter signup error:', error);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // Thumbnail slideshow
    var isSwipeAction = false;
    var thumbTrack = document.querySelector('.product-page__thumbnails');
    var thumbDotsCt = document.querySelector('.product-page__thumbnail-dots');
    var thumbnails = thumbTrack ? Array.from(thumbTrack.querySelectorAll('.product-page__thumbnail')) : [];
    var mainImage = document.querySelector('#product-main-image');
    var THUMBS_PER_GROUP = 4;
    var totalGroups = Math.ceil(thumbnails.length / THUMBS_PER_GROUP);
    var activeGroupIndex = 0;

    function setActiveDot(groupIndex) {
      activeGroupIndex = groupIndex;
      var dots = thumbDotsCt ? thumbDotsCt.querySelectorAll('.product-page__thumbnail-dot') : [];
      Array.from(dots).forEach(function (d, i) {
        d.classList.toggle('is-active', i === groupIndex);
      });
    }

    function scrollToGroup(groupIndex) {
      if (!thumbTrack || !thumbnails.length) return;
      var targetThumb = thumbnails[groupIndex * THUMBS_PER_GROUP];
      if (!targetThumb) return;
      var trackRect = thumbTrack.getBoundingClientRect();
      var thumbRect = targetThumb.getBoundingClientRect();
      thumbTrack.scrollLeft += thumbRect.left - trackRect.left;
      setActiveDot(groupIndex);
    }

    function updateActiveDotFromScroll() {
      if (!thumbTrack || totalGroups <= 1) return;
      var scrollLeft = thumbTrack.scrollLeft;
      var maxScroll = thumbTrack.scrollWidth - thumbTrack.clientWidth;
      if (maxScroll <= 0) {
        setActiveDot(0);
        return;
      }
      var ratio = scrollLeft / maxScroll;
      var groupIndex = Math.round(ratio * (totalGroups - 1));
      if (groupIndex !== activeGroupIndex) setActiveDot(groupIndex);
    }

    var mainImageTrack = document.querySelector('#product-main-image-track');
    var activeIndex = 0;
    if (mainImage) {
      activeIndex = parseInt(mainImage.getAttribute('data-initial-index') || '0', 10);
      if (mainImageTrack && activeIndex > 0) {
        mainImageTrack.style.transition = 'none';
        mainImageTrack.style.transform = 'translateX(-' + (activeIndex * 100) + '%)';
      }
    }

    function selectThumb(thumb, index) {
      if (!mainImageTrack) return;
      
      var targetTransform = 'translateX(-' + (index * 100) + '%)';
      var willAnimate = (mainImageTrack.style.transform !== targetTransform);
      
      if (willAnimate) {
        mainImageTrack.classList.add('is-transitioning');
      }

      var slides = mainImageTrack.querySelectorAll('.product-page__main-image-slide');
      slides.forEach(function (slide, i) {
        var isTarget = (i === index);
        slide.classList.toggle('is-active', isTarget);
        if (!isTarget) {
          slide.classList.remove('is-zoomed');
          var sImg = slide.querySelector('img.product-page__image');
          if (sImg) {
            sImg.style.transform = '';
            sImg.style.transformOrigin = '';
          }
        }
        var slideVideo = slide.querySelector('video');
        if (slideVideo) {
          if (isTarget) {
            if (willAnimate && slideVideo.paused) {
              slideVideo.play().catch(function () {});
            }
          } else {
            slideVideo.pause();
          }
        }
      });

      thumbnails.forEach(function (t, i) {
        t.classList.toggle('product-page__thumbnail--active', i === index);
      });
      
      activeIndex = index;
      
      mainImageTrack.style.transition = 'transform 0.3s ease-out';
      mainImageTrack.style.transform = targetTransform;

      if (!willAnimate) {
        mainImageTrack.classList.remove('is-transitioning');
      }

      var groupIndex = Math.floor(index / THUMBS_PER_GROUP);
      if (groupIndex !== activeGroupIndex) {
        scrollToGroup(groupIndex);
      }
    }

    // Create dots per group of 4 and wire thumbnail clicks
    if (thumbnails.length && thumbDotsCt) {
      // Only create dots if there are more than 4 thumbnails
      if (totalGroups > 1) {
        for (var g = 0; g < totalGroups; g++) {
          (function (groupIndex) {
            var dot = document.createElement('button');
            dot.className = 'product-page__thumbnail-dot' + (groupIndex === 0 ? ' is-active' : '');
            dot.setAttribute(
              'aria-label',
              'View images ' +
                (groupIndex * THUMBS_PER_GROUP + 1) +
                ' to ' +
                Math.min((groupIndex + 1) * THUMBS_PER_GROUP, thumbnails.length)
            );
            dot.addEventListener('click', function () {
              scrollToGroup(groupIndex);
            });
            thumbDotsCt.appendChild(dot);
          })(g);
        }
      }

      // Update active dot on scroll
      var scrollTimeout;
      if (thumbTrack) {
        thumbTrack.addEventListener('scroll', function () {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(updateActiveDotFromScroll, 100);
        });
      }

      thumbnails.forEach(function (thumb, index) {
        thumb.addEventListener('click', function (e) {
          if (Math.abs(dragVelocity) > 0.5) {
            e.preventDefault();
            return;
          }
          selectThumb(thumb, index);
        });
      });
    }

    // Swipe/drag gesture navigation on main product image (real-time slideshow sliding)
    if (mainImage && mainImageTrack && thumbnails.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchEndX = 0;
      var isDraggingImage = false;
      var isSwipeDirectionDetermined = false;
      var trackWidth = 0;
      var startPx = 0;
      var swipeThreshold = 40; // threshold in px to register a swipe

      // Touch support for mobile
      mainImage.addEventListener('touchstart', function (e) {
        if (mainImageTrack.querySelector('.product-page__main-image-slide.is-zoomed')) {
          isDraggingImage = false;
          return;
        }
        var touch = e.changedTouches[0];
        touchStartX = touch.pageX;
        touchStartY = touch.pageY;
        isDraggingImage = true;
        isSwipeDirectionDetermined = false;
        isSwipeAction = false;
        trackWidth = mainImage.getBoundingClientRect().width || 1;
        startPx = -activeIndex * trackWidth;
        mainImageTrack.style.transition = 'none';
        mainImageTrack.classList.add('is-transitioning');
      }, { passive: true });

      mainImage.addEventListener('touchmove', function (e) {
        if (!isDraggingImage) return;
        var touch = e.changedTouches[0];
        var deltaX = touch.pageX - touchStartX;
        var deltaY = touch.pageY - touchStartY;
        
        if (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6) {
          isSwipeAction = true;
        }

        if (!isSwipeDirectionDetermined) {
          // If vertical movement is greater than horizontal, cancel swipe to let page scroll normally
          if (Math.abs(deltaY) > Math.abs(deltaX)) {
            isDraggingImage = false;
            return;
          }
          isSwipeDirectionDetermined = true;
        }

        // Horizontal swipe is confirmed: block vertical scroll during drag
        if (e.cancelable) {
          e.preventDefault();
        }
        
        var currentPx = startPx + deltaX;
        
        // Add resistance if pulling past bounds
        if (currentPx > 0) {
          currentPx = currentPx / 3;
        } else if (currentPx < -(thumbnails.length - 1) * trackWidth) {
          var overLimit = currentPx - (-(thumbnails.length - 1) * trackWidth);
          currentPx = -(thumbnails.length - 1) * trackWidth + overLimit / 3;
        }
        
        mainImageTrack.style.transform = 'translateX(' + currentPx + 'px)';
      }, { passive: false });

      mainImage.addEventListener('touchend', function (e) {
        if (!isDraggingImage) return;
        isDraggingImage = false;
        var touch = e.changedTouches[0];
        touchEndX = touch.pageX;
        var deltaX = touchEndX - touchStartX;
        
        mainImageTrack.style.transition = 'transform 0.3s ease-out';
        
        if (Math.abs(deltaX) > swipeThreshold) {
          if (deltaX > 0 && activeIndex > 0) {
            activeIndex--;
          } else if (deltaX < 0 && activeIndex < thumbnails.length - 1) {
            activeIndex++;
          }
        }
        selectThumb(thumbnails[activeIndex], activeIndex);
      }, { passive: true });

      // Mouse support for desktop drag-to-swipe
      mainImage.addEventListener('mousedown', function (e) {
        if (mainImageTrack.querySelector('.product-page__main-image-slide.is-zoomed')) {
          isDraggingImage = false;
          return;
        }
        isDraggingImage = true;
        touchStartX = e.pageX;
        touchStartY = e.pageY;
        isSwipeAction = false;
        trackWidth = mainImage.getBoundingClientRect().width || 1;
        startPx = -activeIndex * trackWidth;
        mainImageTrack.style.transition = 'none';
        mainImageTrack.classList.add('is-transitioning');
        mainImage.style.cursor = 'grabbing';
      });

      mainImage.addEventListener('mousemove', function (e) {
        if (!isDraggingImage) return;
        e.preventDefault(); // Prevent text selection/dragging of ghost image
        var deltaX = e.pageX - touchStartX;
        var deltaY = e.pageY - touchStartY;
        
        if (Math.abs(deltaX) > 6 || Math.abs(deltaY) > 6) {
          isSwipeAction = true;
        }

        var currentPx = startPx + deltaX;
        
        // Add resistance if pulling past bounds
        if (currentPx > 0) {
          currentPx = currentPx / 3;
        } else if (currentPx < -(thumbnails.length - 1) * trackWidth) {
          var overLimit = currentPx - (-(thumbnails.length - 1) * trackWidth);
          currentPx = -(thumbnails.length - 1) * trackWidth + overLimit / 3;
        }
        
        mainImageTrack.style.transform = 'translateX(' + currentPx + 'px)';
      });

      window.addEventListener('mouseup', function (e) {
        if (!isDraggingImage) return;
        isDraggingImage = false;
        touchEndX = e.pageX;
        mainImage.style.cursor = 'grab';
        
        var deltaX = touchEndX - touchStartX;
        mainImageTrack.style.transition = 'transform 0.3s ease-out';
        
        if (Math.abs(deltaX) > swipeThreshold) {
          if (deltaX > 0 && activeIndex > 0) {
            activeIndex--;
          } else if (deltaX < 0 && activeIndex < thumbnails.length - 1) {
            activeIndex++;
          }
        }
        selectThumb(thumbnails[activeIndex], activeIndex);
      });

      // Prevent native image dragging
      mainImage.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      // Style container to show grab hand cursor
      mainImage.style.cursor = 'grab';

      // Clear transitioning class when snap transition finishes
      mainImageTrack.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform') {
          mainImageTrack.classList.remove('is-transitioning');
        }
      });
    }

    // Drag-to-scroll on thumbnail track
    var dragVelocity = 0;
    if (thumbTrack) {
      var dragging = false,
        dragStartX = 0,
        dragScrollLeft = 0,
        dragLastX = 0,
        dragLastTime = 0;

      thumbTrack.addEventListener('mousedown', function (e) {
        dragging = true;
        dragStartX = e.pageX - thumbTrack.offsetLeft;
        dragScrollLeft = thumbTrack.scrollLeft;
        dragLastX = e.pageX;
        dragLastTime = Date.now();
        dragVelocity = 0;
        thumbTrack.style.cursor = 'grabbing';
        thumbTrack.style.scrollBehavior = 'auto';
      });
      thumbTrack.addEventListener('mouseleave', function () {
        dragging = false;
        thumbTrack.style.cursor = 'grab';
        thumbTrack.style.scrollBehavior = 'smooth';
      });
      thumbTrack.addEventListener('mouseup', function () {
        dragging = false;
        thumbTrack.style.cursor = 'grab';
        thumbTrack.style.scrollBehavior = 'smooth';
      });
      thumbTrack.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        thumbTrack.scrollLeft = dragScrollLeft - (e.pageX - dragStartX) * 1.5;
        var now = Date.now(),
          diff = now - dragLastTime;
        if (diff > 0) dragVelocity = (e.pageX - dragLastX) / diff;
        dragLastX = e.pageX;
        dragLastTime = now;
      });
    }

    // Quantity buttons
    var quantityInput = document.querySelector('#quantity');
    var minusBtn = document.querySelector('[data-quantity-minus]');
    var plusBtn = document.querySelector('[data-quantity-plus]');

    if (minusBtn && quantityInput) {
      minusBtn.addEventListener('click', function () {
        var currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });
    }

    if (plusBtn && quantityInput) {
      plusBtn.addEventListener('click', function () {
        var currentValue = parseInt(quantityInput.value) || 1;
        quantityInput.value = currentValue + 1;
      });
    }

    // Variant selection
    var productJSON = JSON.parse(document.getElementById('product-json').textContent);
    var variantImagesData = JSON.parse(document.getElementById('variant-images-json').textContent);
    var form = document.querySelector('#product-form');
    var allSlides = mainImageTrack ? Array.from(mainImageTrack.querySelectorAll('.product-page__main-image-slide')) : [];
    var allThumbnails = thumbnails.slice();
    var currentGalleryVariantId = null;


    function getSelectedOptions() {
      var optionInputs = form.querySelectorAll('[name^="option-"]');
      var options = [];
      var seen = {};
      optionInputs.forEach(function (input) {
        if (input.type === 'radio') {
          var checked = form.querySelector('[name="' + input.name + '"]:checked');
          if (checked && !seen[input.name]) {
            options.push(checked.value);
            seen[input.name] = true;
          }
        } else {
          if (!seen[input.name]) {
            options.push(input.value);
            seen[input.name] = true;
          }
        }
      });
      return options;
    }

    function findMatchingVariant(options) {
      for (var i = 0; i < productJSON.variants.length; i++) {
        var variant = productJSON.variants[i];
        var match = true;
        for (var j = 0; j < options.length; j++) {
          if (variant.options[j] !== options[j]) {
            match = false;
            break;
          }
        }
        if (match) return variant;
      }
      return null;
    }

    // Rebuild the gallery (slides + thumbnails) with a new set of images
    function rebuildGallery(images) {
      if (!mainImageTrack) return;

      // Rebuild main image slides
      mainImageTrack.innerHTML = '';
      images.forEach(function (img, i) {
        var slide = document.createElement('div');
        slide.className = 'product-page__main-image-slide' + (i === 0 ? ' is-active' : '');
        slide.setAttribute('data-slide-index', i);
        if ((img.media_type === 'video' || img.media_type === 'external_video') && img.video_html) {
          slide.innerHTML = img.video_html;
        } else {
          var imgEl = document.createElement('img');
          imgEl.src = img.src_large;
          imgEl.alt = img.alt || '';
          imgEl.className = 'product-page__image';
          imgEl.loading = i === 0 ? 'eager' : 'lazy';
          slide.appendChild(imgEl);
        }
        mainImageTrack.appendChild(slide);
      });

      // Reset track position
      mainImageTrack.style.transition = 'none';
      mainImageTrack.style.transform = 'translateX(0%)';
      activeIndex = 0;

      // Rebuild thumbnails
      var thumbWrapper = document.querySelector('.product-page__thumbnails-wrapper');
      if (images.length > 1) {
        if (!thumbWrapper) {
          // Create thumbnails wrapper if it doesn't exist
          thumbWrapper = document.createElement('div');
          thumbWrapper.className = 'product-page__thumbnails-wrapper';
          var thumbContainer = document.createElement('div');
          thumbContainer.className = 'product-page__thumbnails';
          var dotsContainer = document.createElement('div');
          dotsContainer.className = 'product-page__thumbnail-dots';
          thumbWrapper.appendChild(thumbContainer);
          thumbWrapper.appendChild(dotsContainer);
          var mediaEl = document.querySelector('.product-page__media');
          if (mediaEl) mediaEl.appendChild(thumbWrapper);
        }

        var thumbContainer = thumbWrapper.querySelector('.product-page__thumbnails');
        thumbContainer.innerHTML = '';
        images.forEach(function (img, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'product-page__thumbnail' + (i === 0 ? ' product-page__thumbnail--active' : '');
          btn.setAttribute('data-thumb-index', i);
          var thumbImg = document.createElement('img');
          thumbImg.src = img.src_thumb;
          thumbImg.alt = img.alt || '';
          thumbImg.loading = 'lazy';
          btn.appendChild(thumbImg);

          if (img.media_type === 'video' || img.media_type === 'external_video') {
            var badge = document.createElement('span');
            badge.className = 'product-page__thumbnail-badge';
            badge.setAttribute('aria-hidden', 'true');
            badge.innerHTML = '<svg class="product-page__thumbnail-play-icon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
            btn.appendChild(badge);
          }

          thumbContainer.appendChild(btn);
        });

        thumbWrapper.style.display = '';

        // Update references
        thumbTrack = thumbContainer;
        thumbnails = Array.from(thumbContainer.querySelectorAll('.product-page__thumbnail'));
        allThumbnails = thumbnails.slice();

        // Rebind thumbnail clicks
        thumbnails.forEach(function (thumb, index) {
          thumb.addEventListener('click', function (e) {
            if (Math.abs(dragVelocity) > 0.5) {
              e.preventDefault();
              return;
            }
            selectThumb(thumb, index);
          });
        });

        // Rebuild dots
        totalGroups = Math.ceil(thumbnails.length / THUMBS_PER_GROUP);
        thumbDotsCt = thumbWrapper.querySelector('.product-page__thumbnail-dots');
        if (thumbDotsCt) {
          thumbDotsCt.innerHTML = '';
          if (totalGroups > 1) {
            for (var g = 0; g < totalGroups; g++) {
              (function (groupIndex) {
                var dot = document.createElement('button');
                dot.className = 'product-page__thumbnail-dot' + (groupIndex === 0 ? ' is-active' : '');
                dot.addEventListener('click', function () { scrollToGroup(groupIndex); });
                thumbDotsCt.appendChild(dot);
              })(g);
            }
          }
          activeGroupIndex = 0;
        }
      } else if (thumbWrapper) {
        // Only 1 image or 0 — hide thumbnails
        thumbWrapper.style.display = 'none';
        thumbnails = [];
        allThumbnails = [];
      }

      // Update slide references for swipe
      allSlides = Array.from(mainImageTrack.querySelectorAll('.product-page__main-image-slide'));
    }

    function updateVariant() {
      var options = getSelectedOptions();
      var variant = findMatchingVariant(options);
      if (!variant) return;

      // Update hidden variant id input
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;

      // Update URL
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Update add-to-cart & buy-now button states
      var addToCartBtn = form.querySelector('.product-page__add-to-cart');
      var buyNowBtn = form.querySelector('.product-page__buy-now');
      if (addToCartBtn) {
        var cartTextSpan = addToCartBtn.querySelector('.product-page__add-to-cart-text');
        var addText = addToCartBtn.getAttribute('data-add-text');
        var soldOutText = addToCartBtn.getAttribute('data-sold-out-text');
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.style.display = '';
          if (cartTextSpan && addText) cartTextSpan.textContent = addText;
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.style.display = 'none';
          if (cartTextSpan && soldOutText) cartTextSpan.textContent = soldOutText;
        }
      }
      if (buyNowBtn) {
        var buyTextSpan = buyNowBtn.querySelector('.product-page__buy-now-text');
        var buyNowText = buyNowBtn.getAttribute('data-buy-now-text');
        var soldOutText = buyNowBtn.getAttribute('data-sold-out-text');
        if (variant.available) {
          buyNowBtn.disabled = false;
          if (buyTextSpan && buyNowText) buyTextSpan.textContent = buyNowText;
        } else {
          buyNowBtn.disabled = true;
          if (buyTextSpan && soldOutText) buyTextSpan.textContent = soldOutText;
        }
      }

      // Swap gallery images based on variant
      var variantData = variantImagesData.variants[String(variant.id)];
      var targetGalleryId = null;

      if (variantData && variantData.hasCustomImages && variantData.images.length > 0) {
        targetGalleryId = 'variant-' + variant.id;
      } else {
        targetGalleryId = 'default';
      }

      // Only rebuild gallery if we're switching to a different image set
      if (targetGalleryId !== currentGalleryVariantId) {
        currentGalleryVariantId = targetGalleryId;
        if (targetGalleryId === 'default') {
          rebuildGallery(variantImagesData.defaultImages);
        } else {
          rebuildGallery(variantData.images);
        }
      }
    }

    // Color swatch click handler
    var colorPicker = document.querySelector('#product-color-picker');
    if (colorPicker) {
      var swatchButtons = colorPicker.querySelectorAll('.product-page__swatch');
      swatchButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var colorValue = btn.getAttribute('data-color-value');
          var optionPosition = btn.getAttribute('data-option-position');

          // Update active swatch styling
          swatchButtons.forEach(function (s) {
            s.classList.remove('product-page__swatch--active');
          });
          btn.classList.add('product-page__swatch--active');

          // Update hidden radio input
          var radios = form.querySelectorAll('input[name="option-' + optionPosition + '"]');
          radios.forEach(function (radio) {
            if (radio.value === colorValue) {
              radio.checked = true;
            }
          });

          updateVariant();
        });
      });
    }

    // Size swatch click handler
    var sizePicker = document.querySelector('#product-size-picker');
    if (sizePicker) {
      var sizeSwatchButtons = sizePicker.querySelectorAll('.product-page__swatch');
      sizeSwatchButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sizeValue = btn.getAttribute('data-size-value');
          var optionPosition = btn.getAttribute('data-option-position');

          // Update active swatch styling
          sizeSwatchButtons.forEach(function (s) {
            s.classList.remove('product-page__swatch--active');
          });
          btn.classList.add('product-page__swatch--active');

          // Update hidden radio input
          var radios = form.querySelectorAll('input[name="option-' + optionPosition + '"]');
          radios.forEach(function (radio) {
            if (radio.value === sizeValue) {
              radio.checked = true;
            }
          });

          updateVariant();
        });
      });
    }


    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.name && e.target.name.indexOf('option-') === 0) {
          updateVariant();
        }
      });

      // AJAX Add to Cart
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var addToCartBtn = form.querySelector('.product-page__add-to-cart');
        var textSpan = addToCartBtn ? addToCartBtn.querySelector('.product-page__add-to-cart-text') : null;
        var variantId = form.querySelector('input[name="id"]').value;
        var quantity = form.querySelector('input[name="quantity"]').value || 1;
        var originalText = textSpan ? textSpan.textContent : (addToCartBtn ? addToCartBtn.textContent : 'AGREGAR AL CARRITO');

        if (addToCartBtn) addToCartBtn.disabled = true;
        if (textSpan) {
          textSpan.innerHTML = '<span class="loading-dots"><span>.</span><span>.</span><span>.</span></span>';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: parseInt(variantId, 10),
            quantity: parseInt(quantity, 10),
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            return fetch('/cart.js', {
              headers: { Accept: 'application/json' },
            });
          })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            var cartCountEl = document.querySelector('.header__cart-count');
            var cartIcon = document.querySelector('.header__icon--cart');

            if (cart.item_count > 0) {
              if (cartCountEl) {
                cartCountEl.textContent = cart.item_count;
              } else if (cartIcon) {
                var span = document.createElement('span');
                span.className = 'header__cart-count';
                span.textContent = cart.item_count;
                cartIcon.insertBefore(span, cartIcon.firstChild);
              }
            }

            if (textSpan) textSpan.textContent = originalText;
            if (addToCartBtn) addToCartBtn.disabled = false;

            // Trigger custom event to update cart and open side cart drawer
            window.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(function (error) {
            console.error('Add to cart error:', error);
            if (textSpan) textSpan.textContent = originalText;
            if (addToCartBtn) addToCartBtn.disabled = false;
          });
      });

      // Buy Now Direct Checkout
      var buyNowBtn = form.querySelector('.product-page__buy-now');
      if (buyNowBtn) {
        buyNowBtn.addEventListener('click', function (e) {
          if (buyNowBtn.disabled) return;
          e.preventDefault();
          e.stopPropagation();

          var buyTextSpan = buyNowBtn.querySelector('.product-page__buy-now-text');
          var variantId = form.querySelector('input[name="id"]').value;
          var quantity = form.querySelector('input[name="quantity"]').value || 1;

          buyNowBtn.disabled = true;
          if (buyTextSpan) {
            buyTextSpan.innerHTML = '<span class="loading-dots"><span>.</span><span>.</span><span>.</span></span>';
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: parseInt(variantId, 10),
              quantity: parseInt(quantity, 10),
            }),
          })
            .then(function () {
              window.location.href = '/checkout';
            })
            .catch(function (error) {
              console.error('Buy now error:', error);
              window.location.href = '/checkout';
            });
        });
      }
    }

    function initImageZoom() {
      var mediaContainer = document.querySelector('.product-page__media');
      if (!mediaContainer) return;

      function updateZoomPosition(clientX, clientY, targetEl, isTouch) {
        var slide = targetEl.closest('.product-page__main-image-slide.is-zoomed');
        if (!slide) return;
        var img = slide.querySelector('img.product-page__image');
        if (!img) return;

        var rect = slide.getBoundingClientRect();
        var x = Math.max(0, Math.min(rect.width, clientX - rect.left));
        var y = Math.max(0, Math.min(rect.height, clientY - rect.top));
        var rawXPct = (x / rect.width) * 100;
        var rawYPct = (y / rect.height) * 100;

        // Invert touch percentages so finger dragging moves image in natural direction
        var xPct = isTouch ? (100 - rawXPct) : rawXPct;
        var yPct = isTouch ? (100 - rawYPct) : rawYPct;

        img.style.transformOrigin = xPct + '% ' + yPct + '%';
      }

      mediaContainer.addEventListener('click', function(e) {
        if (isSwipeAction) {
          isSwipeAction = false;
          return;
        }

        var slide = e.target.closest('.product-page__main-image-slide');
        if (!slide) return;

        // Ignore clicks on video controls, video element, or iframe
        if (e.target.closest('.product-page__video-controls') || e.target.closest('video') || e.target.closest('iframe')) {
          return;
        }

        var img = slide.querySelector('img.product-page__image');
        if (!img) return;

        var isZoomed = slide.classList.contains('is-zoomed');

        if (!isZoomed) {
          var allSlides = mediaContainer.querySelectorAll('.product-page__main-image-slide');
          allSlides.forEach(function(s) {
            s.classList.remove('is-zoomed');
            var sImg = s.querySelector('img.product-page__image');
            if (sImg) {
              sImg.style.transform = '';
              sImg.style.transformOrigin = '';
            }
          });

          slide.classList.add('is-zoomed');
          var clientX = e.clientX;
          var clientY = e.clientY;
          var isTouch = false;
          if ((clientX === undefined || clientX === 0) && e.changedTouches && e.changedTouches[0]) {
            clientX = e.changedTouches[0].clientX;
            clientY = e.changedTouches[0].clientY;
            isTouch = true;
          }
          if (clientX !== undefined && clientY !== undefined) {
            updateZoomPosition(clientX, clientY, slide, isTouch);
          } else {
            img.style.transformOrigin = '50% 50%';
          }
          img.style.transform = 'scale(2.5)';
        } else {
          slide.classList.remove('is-zoomed');
          img.style.transform = '';
          img.style.transformOrigin = '';
        }
      });

      mediaContainer.addEventListener('mousemove', function(e) {
        updateZoomPosition(e.clientX, e.clientY, e.target, false);
      });

      mediaContainer.addEventListener('touchstart', function(e) {
        var slide = e.target.closest('.product-page__main-image-slide.is-zoomed');
        if (slide) {
          if (e.cancelable) {
            e.preventDefault();
          }
        }
      }, { passive: false });

      mediaContainer.addEventListener('touchmove', function(e) {
        var slide = e.target.closest('.product-page__main-image-slide.is-zoomed');
        if (slide) {
          if (e.cancelable) {
            e.preventDefault();
          }
          if (e.touches && e.touches[0]) {
            updateZoomPosition(e.touches[0].clientX, e.touches[0].clientY, e.target, true);
          }
        }
      }, { passive: false });

      mediaContainer.addEventListener('mouseleave', function() {
        var zoomedSlides = mediaContainer.querySelectorAll('.product-page__main-image-slide.is-zoomed');
        zoomedSlides.forEach(function(slide) {
          slide.classList.remove('is-zoomed');
          var img = slide.querySelector('img.product-page__image');
          if (img) {
            img.style.transform = '';
            img.style.transformOrigin = '';
          }
        });
      });
    }

    function initVideoControls() {
      var mediaContainer = document.querySelector('.product-page__media');
      if (!mediaContainer) return;

      mediaContainer.addEventListener('click', function(e) {
        var muteBtn = e.target.closest('.product-page__video-mute-btn');
        var fullscreenBtn = e.target.closest('.product-page__video-fullscreen-btn');
        var videoEl = e.target.closest('video');

        if (muteBtn) {
          e.stopPropagation();
          var wrapper = muteBtn.closest('.product-page__video-wrapper');
          var video = wrapper ? wrapper.querySelector('video') : null;
          if (video) {
            video.muted = !video.muted;
            var mutedIcon = muteBtn.querySelector('.icon-muted');
            var unmutedIcon = muteBtn.querySelector('.icon-unmuted');
            if (mutedIcon && unmutedIcon) {
              mutedIcon.style.display = video.muted ? 'block' : 'none';
              unmutedIcon.style.display = video.muted ? 'none' : 'block';
            }
          }
          return;
        }

        if (fullscreenBtn) {
          e.stopPropagation();
          var wrapper = fullscreenBtn.closest('.product-page__video-wrapper') || fullscreenBtn.closest('.product-page__main-image-slide');
          var video = wrapper ? (wrapper.querySelector('video') || wrapper.querySelector('iframe')) : null;
          var targetEl = video || wrapper;
          if (targetEl) {
            if (targetEl.requestFullscreen) {
              targetEl.requestFullscreen();
            } else if (targetEl.webkitRequestFullscreen) {
              targetEl.webkitRequestFullscreen();
            } else if (targetEl.mozRequestFullScreen) {
              targetEl.mozRequestFullScreen();
            } else if (targetEl.msRequestFullscreen) {
              targetEl.msRequestFullscreen();
            }
          }
          return;
        }

        var videoWrapper = e.target.closest('.product-page__video-wrapper') || e.target.closest('.product-page__main-image-slide');
        var videoEl = videoWrapper ? videoWrapper.querySelector('video') : e.target.closest('video');

        if (videoEl) {
          e.stopPropagation();
          if (videoEl.paused) {
            videoEl.play().catch(function() {});
          } else {
            videoEl.pause();
          }
        }
      });
    }

    initImageZoom();
    initVideoControls();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class Slideshow {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.slideshow__track');
      this.slides = container.querySelectorAll('.slideshow__slide');
      this.indicators = container.querySelectorAll('.slideshow__indicator');
      if (this.slides.length <= 1) return;

      this.duration = parseInt(container.getAttribute('data-autoplay-speed')) || 5000;
      this.currentIndex = 0;
      this.intervalId = null;

      this.init();
    }

    init() {
      this.preloadImages();
      this.startAutoplay();
      this.setupSwipe();
      this.setupIndicators();

      // Handle Shopify theme editor events
      document.addEventListener('shopify:block:select', (event) => {
        if (event.target.closest('.slideshow') === this.container) {
          const blockId = event.detail.blockId;
          const slideIndex = Array.from(this.slides).findIndex(slide => slide.getAttribute('data-block-id') === blockId);
          if (slideIndex > -1) {
            this.goToSlide(slideIndex);
            this.stopAutoplay();
          }
        }
      });

      document.addEventListener('shopify:block:deselect', (event) => {
        if (event.target.closest('.slideshow') === this.container) {
          this.startAutoplay();
        }
      });
    }

    preloadImages() {
      this.slides.forEach(slide => {
        const imgs = slide.querySelectorAll('img');
        imgs.forEach(img => {
          if (img.complete) {
            if (img.decode) img.decode().catch(() => {});
            return;
          }
          const tempImg = new Image();
          if (img.srcset) tempImg.srcset = img.srcset;
          tempImg.src = img.src;
          if (img.decode) {
            img.decode().catch(() => {});
          }
        });
      });
    }

    setupIndicators() {
      this.indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => {
          this.stopAutoplay();
          this.goToSlide(index);
          this.startAutoplay();
        });
      });
    }

    setupSwipe() {
      let startX = 0;
      let startY = 0;
      let isSwiping = false;
      let wasDragged = false;
      const threshold = 50;

      this.container.addEventListener('click', (e) => {
        if (wasDragged) {
          e.preventDefault();
          e.stopPropagation();
          wasDragged = false;
        }
      }, true);

      this.container.addEventListener('touchstart', (e) => {
        this.stopAutoplay();
        startX = e.changedTouches[0].pageX;
        startY = e.changedTouches[0].pageY;
        isSwiping = true;
      }, { passive: true });

      this.container.addEventListener('touchcancel', () => {
        if (!isSwiping) return;
        isSwiping = false;
        this.startAutoplay();
      }, { passive: true });

      this.container.addEventListener('touchend', (e) => {
        if (!isSwiping) return;
        isSwiping = false;
        const deltaX = e.changedTouches[0].pageX - startX;
        const deltaY = e.changedTouches[0].pageY - startY;

        // Only count horizontal swipes
        if (Math.abs(deltaX) >= threshold && Math.abs(deltaX) > Math.abs(deltaY)) {
          wasDragged = true;
          if (deltaX < 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        }
        this.startAutoplay();
      }, { passive: true });

      // Mouse drag support for desktop
      let mouseStartX = 0;
      let mouseDown = false;

      this.container.addEventListener('mousedown', (e) => {
        this.stopAutoplay();
        mouseDown = true;
        mouseStartX = e.pageX;
      });

      window.addEventListener('mouseup', (e) => {
        if (!mouseDown) return;
        mouseDown = false;
        const deltaX = e.pageX - mouseStartX;

        if (Math.abs(deltaX) >= threshold) {
          wasDragged = true;
          if (deltaX < 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        }
        this.startAutoplay();
      });

      // Prevent native image dragging
      this.container.addEventListener('dragstart', (e) => e.preventDefault());
    }

    startAutoplay() {
      this.stopAutoplay();
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, this.duration);
    }

    stopAutoplay() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    prevSlide() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;
      this.currentIndex = index;

      // Update track transform
      if (this.track) {
        this.track.style.transform = `translateX(-${index * 100}%)`;
      }

      // Update slide active state
      this.slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });

      // Update indicators active state
      this.indicators.forEach((indicator, i) => {
        if (i === index) {
          indicator.classList.add('is-active');
        } else {
          indicator.classList.remove('is-active');
        }
      });
    }
  }

  // Initialize all slideshows on the page
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.slideshow').forEach(slideshow => {
      new Slideshow(slideshow);
    });
  });

  // Re-initialize on Shopify section load
  document.addEventListener('shopify:section:load', (event) => {
    const slideshow = event.target.querySelector('.slideshow');
    if (slideshow) {
      new Slideshow(slideshow);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
